module.exports = __webpack_public_path__ + "static/media/mini_onboarding_thumb_vertical.a2cd1c63.svg";